export enum localStorageKeys {
  // we like to be obscure around here: https://www.md5hashgenerator.com/
  SID = 'SID',
  refURL = 'refURL'
}


// WEBPACK FOOTER //
// ./src/utils/localStorageKeys.ts